var React = require('react');
var css = require('./table.scss');

/**
 * 使用方法
 * <Table data={table}/>
 * table: {
    struct: [
        { title: '手机号码', key: function(d) {
            return <a>{d.phone}</a>;
        } },
        { title: '备注', key: 'remark' },
        { title: '更新时间', key: 'time' }
    ],
    data: [
        { phone: '13111111111', remark: '123', time: '2018-01-01' },
        { phone: '13122222222', remark: '456', time: '2018-02-02' },
        { phone: '13133333333', remark: '789', time: '2018-03-03' },
        { phone: '13144444444', remark: '000', time: '2018-04-04' }
    ],
    stripe: true,
    noBorder: false
}
 * 修改了隔行背景色的样式方式，增加stripe，true表示隔行高亮
 * 增加noBorder，true表示表格无边框
 */

var BaseTable = React.createClass({
    render: function () {
        var data = this.props.data;
        let cls = ['fp-table', 'fp-border'];
//      let cls = ['ltable'];
        if (this.props.data.noBorder) {
            cls.push('fp-no-border');
        }
        if (this.props.className) {
            cls.push(this.props.className);
        }
        let length = data.struct.length
        data.struct.map(o=>{
            if (o.hidden == "true"){
                length = length-1
            }
        })
        return <table className={cls.join(' ')} style={this.props.style}>
            <thead>
                <tr>
                    {
                        data.struct.map(function (o, i) {
                            if (o.hidden == "true"){
                                return ;
                            }
                            if (typeof o.title == 'function') {
                                return <th className={o.className || ''} width={o.width}>{o.title.call(this, o, i)}</th>;
                            } else {
                                return <th className={o.className || ''} width={o.width}>{o.title}</th>;
                            }
                        }.bind(this))
                    }
                </tr>
            </thead>
            <tbody>
                {
                    data.data.length ? data.data.map(function (o, i) {
                        var className;
                        if (this.props.data.stripe) {
                            className = i % 2 ? 'fp-stripe' : '';
                        }

                        return <tr className={className} data-index={i}>
                            {
                                data.struct.map(function (p, e) {
                                    if (p.hidden == "true"){
                                        return ;
                                    }
                                    if (typeof p.key == 'function') {
                                        return <td className={p.className || ''}>{p.key.call(this, o, i, e, p)}</td>;
                                    } else {
                                        return <td className={p.className || ''}>{o[p.key]}</td>;
                                    }
                                }.bind(this))
                            }
                        </tr>;
                    }.bind(this)) : (
                        <tr>
                            <td style={{ 'text-align': 'center' }} colSpan={length}>{this.props.emptyText || '未查询到数据'}</td>
                        </tr>
                    )
                }
            </tbody>
        </table>;
    }
});

module.exports = BaseTable;



// WEBPACK FOOTER //
// ./component/table/table.js